skrilla.controller('createMarketCtrl', function ($scope, searchService, modalService, cacheService, $stateParams, srefService, bettingReferenceService, customMarketService) {
  $scope.market = {
    marketType: 'CUSTOM',
    eventType: $stateParams['eventType'],
    eventId: $stateParams['eventId'],
    attributes: {
      promotionCashDisabled: true
    },
    nextBetStop: null,
    leadMarketId: null,
    category: null,

  };
  $scope.eventTypes = bettingReferenceService.eventTypes()
  $scope.outcomeTypes = bettingReferenceService.outcomeTypes()
  $scope.marketTypes = bettingReferenceService.marketTypes()
  $scope.categories = bettingReferenceService.marketCategories()
  $scope.campaigns = [];


  $scope.create = function () {
    const attributes = {};
    const toCents = (field) => {
      if ($scope.market.attributes[field]) {
        attributes[field] = Math.round($scope.market.attributes[field] * 100)
      }
    }
    toCents('maxStake')
    toCents('maxLiability')
    toCents('maxUserLiability')

    attributes.promotionCashDisabled = $scope.market.attributes.promotionCashDisabled


    const market = {
      ...$scope.market,
      outcomes: $scope.outcomes,
      campaignIds: $scope.campaigns.map(function (c) {
        return c.id
      }),
      attributes
    };

    if ($scope.bettingDisabled) {
      market.disabledProducts = ["BETTING"]
    }

    modalService.confirm("Are you sure you'd like to create this  market?", function () {
      searchService.post("betting/markets/", market, "Market successfully created").then(function (response) {
        modalService.dismissAll();
        srefService.go("bettingMarketDetails", {id: response.data.market.id})
      });
    });
  }

  $scope.addOutcome = function () {
    customMarketService.addOutcome($scope.outcomes)
  }

  $scope.removeOutcome = function (outcome) {
    $scope.outcomes = customMarketService.removeOutcome($scope.outcomes, outcome)
  }

  $scope.selectCompetitor = function (outcome, type) {
    customMarketService.selectCompetitor(outcome, $scope.sport, type);
  }

  $scope.getMarkets = function () {
    return searchService.get("betting/markets?eventId=" + $scope.market.eventId).then(function (response) {
      $scope.leadMarkets = response.data.result.map((market) => {
        market.label = market.name;
        if (market.attributes?.startingPrice) market.label += " (SP)";
        return market;
      }).sort((a, b) => {
        return $scope.marketTypes.indexOf(a.marketType) - $scope.marketTypes.indexOf(b.marketType);
      });
    });
  }

  $scope.homeAwayOutcomes = function () {
    const match = $scope.match;
    $scope.outcomes = [
      {
        type: 'FRANCHISE_HOME',
        name: match?.homeFranchise?.name ,
        odds: 1.87,
        competitorId: match?.homeFranchise?.id
      },
      {
        type: 'FRANCHISE_AWAY',
        name: match?.awayFranchise?.name,
        odds: 1.87,
        competitorId: match?.awayFranchise?.id
      }
    ]
  };

  $scope.getMatch = function (id) {
    searchService.get('matches/' + id).then(function (response) {
      const match = response.data
      $scope.match = match;
      $scope.sport = match.sport;
      $scope.eventName = match.name
      // $scope.market.name =  match.name
      $scope.outcomes = []
      // $scope.market.nextBetStop = match.scheduledStartTime;
      $scope.eventScheduledStartTime = match.scheduledStartTime;

    });
  };

  $scope.getSeason = function (id) {
    searchService.get('seasons/' + id).then(function (response) {
      const season = response.data;
      $scope.season = season;
      $scope.sport = season.tournament.sport;
      $scope.outcomes = [];
      $scope.eventName = season.name
      $scope.eventScheduledStartTime = season.scheduledStartTime;
    });
  }

  $scope.getMargin = function () {
    if ($scope.outcomes) {
      const margin = Object.values($scope.outcomes)
          .map(value => {
            return 1 / value.odds
          })
          .reduce((acc, a) => {
            return acc + a
          }, 0)
      return Number(margin * 100).toFixed(2)
    } else {
      0.0
    }
  }

  $scope.addCampaigns = function () {
    cacheService.registerObject("campaignsToAddToMarket", []);
    modalService.openModal("/views/addCampaignsToMarket/addCampaignsToMarket.html", true, 'lg', true, true, function () {
      cacheService.getObject("campaignsToAddToMarket").forEach(function (campaign) {
        if (!$scope.campaigns.some(function(c){return c.id === campaign.id})){
          $scope.campaigns.push(campaign);
        }
      });
    })
  }

  $scope.removeCampaign = function(campaign){
    modalService.confirm("Are you sure you'd like to remove this campaign?", function(){
      $scope.campaigns = $scope.campaigns.filter(function(c){return c.id !== campaign.id})
      $scope.$apply();
    })
  }

  $scope.getEvent = function () {
    if ($scope.market.eventType === 'MATCH') {
      $scope.getMatch($scope.market.eventId)
    } else if ($scope.market.eventType === 'SEASON') {
      $scope.getSeason($scope.market.eventId)
    } else {
      $scope.outcomes = [];
    }
    $scope.getMarkets();
  };

  $scope.getEvent()

});
